module.exports = __webpack_public_path__ + "static/media/avani-black-logo.732ae96e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avani-black-logo.png
// module id = 758
// module chunks = 0